import {LOGINCITY} from '../actiontype'
import request from '@/utils/request'
import {loginCityApi} from '@/api'
import sign from '@/utils/sign'
import { getLocationSearch } from '@/utils/utils'
let shareKey = getLocationSearch().shareKey;
export const logincityAction = () => {
  const action = (data) => (
    {
      type: LOGINCITY,
      data
    }
  )
  return async (dispatch) => {
    let data = await request.post(loginCityApi,{
        shareKey
    },{
        ...sign.sign_share,
    })
    if(data.data.data){
        dispatch(action(data.data.data))
    }
  }
}